import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices";
import { toast } from "react-hot-toast";
const apiService = HttpService;

// Initial state of the slice
const initialState = {
  companyData: [],
  useDatafrompending: {},
  activeCompanyData: [],
  pendingCompanyData: [],
  certificateData: [],
  setLinkedParentCompany: null,
  paginationInfo: {},
  getCompanyData: [],
  parentCompanyList: [],
  parentCompanyPaginationInfo: {},
  linkedCompany: null,
  getPendingCompanyData: {},
  updatePendingCompanyData: {},
userDetails : {},
rejectedstaus:null
};

export const createCompany = createAsyncThunk(
  "admin/createCompany",
  async (companyData, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/companies", companyData);
      toast.success(response.data.msg);

      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for fetching Active Company
export const fetchActiveCompany = createAsyncThunk(
  "admin/fetchActiveCompany",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/companies", {
        params: queryParams,
      });
      console.log("response in fetchActiveCompany: ", response);
      // toast.success(response.data.msg);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Cancel Company
export const rejectAproveCompany = createAsyncThunk(
  'admin/rejectAproveCompany',
  async ({ companyId, status,rejectReason, action }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(`/companies/${companyId}`, {
        status,
        action,
        rejectReason
      });
      toast.success(response.data.msg);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const updateUserCompany = createAsyncThunk(
  'shipment/updateUserCompany',
  async ({  userDetails }, { rejectWithValue }) => {
    // console.log('!!update Product!!!',shipmentId,shipmentProductId, productData)
    try {
      // console.log("inside try");
      const response = await apiService.patch(`/users/`, userDetails);
      return response.data; // Assuming the API responds with the updated product data
    } catch (error) {
      // console.log("inside catch",error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for fetching pending Company
export const fetchPendingCompany = createAsyncThunk(
  "admin/fetchPendingCompany",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/companies", {
        params: queryParams,
      });
      console.log("response in fetchPendingCompany: ", response);
      // toast.success(response.data.msg);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An `unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// update copany API for active companies
export const updateCompanyAPI = createAsyncThunk(
  "admin/updateCompanyAPI ",
  async (companyData, { rejectWithValue }) => {
    try {
      const response = await apiService.put("/companies", companyData);
      toast.success(response.data.msg);

      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// update User API for active companies
export const updateUserfromPendingCompany = createAsyncThunk(
  "admin/updateUserfromPendingCompany ",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await apiService.patch("/users", userData);
      toast.success(response.data.msg);

      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// update copany API for pendong companies
export const updatePendingCompany = createAsyncThunk(
  "admin/updatePendingCompany ",
  async (companyData, { rejectWithValue }) => {
    try {
      console.log("Entering in the pending company slice", companyData);
      const url = "/companies/pending";
      const response = await apiService.put(url, companyData);
      toast.success(response.data.msg);

      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for Delete a Company
export const deleteCompanyById = createAsyncThunk(
  "orders/deleteCompanyById",
  async ({ companyId }, { rejectWithValue }) => {
    try {
      // console.log('!!DELETE ORDER!!!',companyId)
      const response = apiService.delete(`/companies/${companyId}`);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const getCompanyDetailsById = createAsyncThunk(
  "admin/getCompanyDetailsById",
  async (companyId, { rejectWithValue }) => {
    try {
      console.log("in company fetch active Id ::", companyId);
      const response = await apiService.get(`/companies/${companyId}`);

      console.log("response in getCompanyDetailsById: ", response);
      // toast.success(response.data.msg);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error getCompanyDetailsById !!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const getPendingCompanyDetailsById = createAsyncThunk(
  "admin/getPendingCompanyDetailsById",
  async ({ companyId, queryParams }, thunkAPI) => {
    try {
      console.log("in company fetch pending Id ::", companyId);
      const response = await apiService.get(`/companies/${companyId}`, {
        params: queryParams,
      });

      console.log("response in getCompanyDetailsById: ", response);
      // toast.success(response.data.msg);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error getCompanyDetailsById !!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for setLinkedParentCompanyById
export const setLinkedParentCompanyById = createAsyncThunk(
  "admin/setLinkedParentCompanyById",
  async ({ linkedParentCompanyId, linkedCompanyData }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(
        `/companies/${linkedParentCompanyId}`,
        linkedCompanyData
      ); // patch

      console.log("response in setLinkedParentCompanyById: ", response);
      toast.success(response.data.msg);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error setLinkedParentCompanyById !!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for GET COMPANY CERTIFICATES
export const getCompanyCertificateById = createAsyncThunk(
  "admin/getCompanyCertificateById",
  async ({ copanyId, queryParams }, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        `/companies/${copanyId}`,
        queryParams
      );
      toast.success(response.data.msg);
      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error getCompanyCertificateById !!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Fetch Certificate Details
export const fetchCompanyCertificateDetails = createAsyncThunk(
  "admin/fetchCompanyCertificateDetails",
  async ({ companyId, queryParams }, thunkAPI) => {
    // Accept URL instead of companyId
    try {
      console.log("Checking CompanyId and QueryParams", companyId, queryParams);
      const response = await apiService.get(`/companies/${companyId}`, {
        params: queryParams,
      }); // Use the URL directly
      console.log('Inside the slice companyCertificateDetails', response)
      return response;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

export const fetchParentCompanyDetails = createAsyncThunk(
  "admin/fetchParentCompanyDetails",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/companies/perentCompany/", {
        params: queryParams,
      });
      console.log("response in fetchActiveCompany: ", response);
      // toast.success(response.data.msg);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const linkedParentCompany = createAsyncThunk(
  "admin/linkedParentCompany",
  async ({ linkedCompanyId, linkedCompanyData }, { rejectWithValue }) => {
    try {
      console.warn("!!!!!Linked!!!!", linkedCompanyId, linkedCompanyData);

      const response = await apiService.patch(
        `/companies/${linkedCompanyId}`,
        linkedCompanyData
      ); // patch
      toast.success(response.data.msg);
      return response.data; //   your API returns the updated order data
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error linked!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    resetCompaniesState: (state) => {
      (state.companyData = []), (state.activeCompanyData = []);
      state.pendingCompanyData = [];
      state.parentCompanyList = [];
      (state.certificateData = []), (state.getCompanyData = []);
      (state.setLinkedParentCompany = null),
        (state.updateCompany = {}),
        (state.paginationInfo = {});
      (state.parentCompanyPaginationInfo = {}),
        (state.linkedCompany = null),
        (state.getPendingCompanyData = {}),
        (state.updatePendingCompanyData = {});
        state.userDetails = {},
        state.rejectedstaus = null
    },
    //   setOrder: (state, action) => {
    //     state.updateCompany = action.payload;
    //   },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetch Active Company
      .addCase(fetchActiveCompany.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchActiveCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.activeCompanyData = action.payload.data.data;
        //   if (action.payload.headers && typeof action.payload.headers === 'object') {
        //   const headers = action.payload.headers ? Object.fromEntries(action.payload.headers.entries()) : {};
        // }
        state.paginationInfo = {
          totalRecords: action.payload.data.totalRecords,
        };
      })
      .addCase(fetchActiveCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      .addCase(fetchPendingCompany.pending, (state) => {
        state.loading = true;
      })
      // Handling fetch Pending Company
      .addCase(fetchPendingCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingCompanyData = action.payload.data.data; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.data.totalRecords,
        };
      })
      .addCase(fetchPendingCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // Update
      .addCase(updateCompanyAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCompanyAPI.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally update orders list or company with the newly created comapny
        state.companyData = action.payload; //   you want to view this comapny next
      })
      .addCase(updateCompanyAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Users from pending Company
      .addCase(updateUserfromPendingCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUserfromPendingCompany.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally update orders list or company with the newly created comapny
        state.useDatafrompending = action.payload; //   you want to view this comapny next
      })
      .addCase(updateUserfromPendingCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update pending
      .addCase(updatePendingCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePendingCompany.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally update orders list or company with the newly created comapny
        state.updatePendingCompanyData = action.payload; //   you want to view this comapny next
      })
      .addCase(updatePendingCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handling createCompany
      .addCase(createCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally update orders list or company with the newly created comapny
        state.companyData = action.payload; //   you want to view this comapny next
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Linked Parent Company
      .addCase(setLinkedParentCompanyById.pending, (state) => {
        state.loading = true;
      })
      .addCase(setLinkedParentCompanyById.fulfilled, (state, action) => {
        state.loading = false;
        state.setLinkedParentCompany = action.payload;
      })
      .addCase(setLinkedParentCompanyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Get Company Detailsby ID
      .addCase(getCompanyDetailsById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyDetailsById.fulfilled, (state, action) => {
        state.loading = false;
        state.getCompanyData = action.payload.data;
      })
      .addCase(getCompanyDetailsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handling getCompanyCertificateById
      .addCase(getCompanyCertificateById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyCertificateById.fulfilled, (state, action) => {
        state.loading = false;
        state.certificateData = action.payload;
      })
      .addCase(getCompanyCertificateById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCompanyCertificateDetails.pending, (state) => {
        state.loading = true;
        
      })
      .addCase(fetchCompanyCertificateDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.certificateData = action.payload.data.data;
      })
      .addCase(fetchCompanyCertificateDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchParentCompanyDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParentCompanyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.parentCompanyList = action.payload.data.data;
        state.parentCompanyPaginationInfo = {
          totalRecords: action.payload.data.totalRecords,
        };
      })
      .addCase(fetchParentCompanyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(linkedParentCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(linkedParentCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.linkedCompany = action.payload;
      })
      .addCase(linkedParentCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPendingCompanyDetailsById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPendingCompanyDetailsById.fulfilled, (state, action) => {
        state.loading = false;
        state.getPendingCompanyData = action.payload.data;
      })
      .addCase(getPendingCompanyDetailsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Order by ID
      .addCase(deleteCompanyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCompanyById.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteCompanyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       // Cancel Order
       .addCase(rejectAproveCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectAproveCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.rejectedstaus = action.payload;

      //   const index = state.companyData.findIndex(company => company.id === action.meta.arg.companyId);
      //   if (index !== -1) {
      //     state.companyData[index] = { ...state.companyData[index], status: status, rejectReason: action.meta.arg.rejectReason };
      //   }
      })
      .addCase(rejectAproveCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
        // Update Users
        .addCase(updateUserCompany.pending, (state) => {
          state.loading = true;
        })
        .addCase(updateUserCompany.fulfilled, (state, action) => {
          state.loading = false;
          // console.log("updateUserCompany",action.payload)
          state.userDetails = action.payload;
        })
        .addCase(updateUserCompany.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  },
});

// Export actions and reducer
export const { resetOrderState } = adminSlice.actions; // , setOrder
export default adminSlice.reducer;
